import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { formatPhone } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

const StyledHeaderContainer = styled.div`
  background-color: #f7f7f7;
  margin: 20px -15px;
  padding-top: 8px;
  text-align: center;
  color: #888888;
`;

const StyledInfoContainer = styled.div`
  font-size: 14px;
  text-align: left;
  padding: 7px;
`;

const StyledContactDetailsContainer = styled.div`
  font-size: 18px;
  color: #4f4f4f;
  padding: 7px;
  display: flex;
  flex-direction: column;
`;

const StyledDetailsTitle = styled.p`
  font-size: 14px;
  margin: 0px;
`;

const StyledRow = styled.div`
  margin-bottom: 5px;
`;

const ContactDetails = props => {
  const { contactDetails } = props;
  if (!contactDetails) return null;
  if (contactDetails.length === 0) return null;

  const officeContactDetails = contactDetails.filter(contact => {
    return contact.contact_card_type === 'office';
  });

  if (officeContactDetails.length === 0) return null;

  return (
    <StyledContactDetailsContainer>
      {officeContactDetails.map((contactCard, index) => {
        return (
          <Fragment>
            {index > 0 && (
              <hr
                style={{
                  borderTop: '2px solid #f7f7f7',
                  margin: '0px 0px 12px 0px',
                }}
              />
            )}
            {contactCard.email && (
              <StyledRow>
                <StyledDetailsTitle>
                  {getTranslatedString('tenantPortal.optOutSection.email')}
                </StyledDetailsTitle>
                <p>{contactCard.email}</p>
              </StyledRow>
            )}
            <StyledRow>
              <StyledDetailsTitle>
                {getTranslatedString('tenantPortal.optOutSection.phoneNumber')}
              </StyledDetailsTitle>
              <p>
                {formatPhone(contactCard.phone_number)}
                {contactCard.phone_number_extension
                  ? ` ext. ${contactCard.phone_number_extension}`
                  : null}
              </p>
            </StyledRow>
          </Fragment>
        );
      })}
    </StyledContactDetailsContainer>
  );
};

const OptOutSection = props => {
  const { contactDetails } = props;

  return (
    <div>
      <StyledHeaderContainer className="row">
        <h5>{getTranslatedString('tenantPortal.optOutSection.header')}</h5>
      </StyledHeaderContainer>
      <StyledInfoContainer>
        <div>
          {getTranslatedString('tenantPortal.optOutSection.info')}{' '}
          <p style={{ fontFamily: 'Circular-Bold' }}>
            {getTranslatedString('tenantPortal.optOutSection.thisMeansThat')}
          </p>
        </div>
        <p>{getTranslatedString('tenantPortal.optOutSection.youHaveTheAbilityToOptBack')}</p>
      </StyledInfoContainer>
      <ContactDetails contactDetails={contactDetails} />
    </div>
  );
};

export default connect(store => {
  return {
    contactDetails: store.dashboard.tenantOverview.contact_details,
  };
})(OptOutSection);
